import { render } from "./BaseCheckboxGroup.vue?vue&type=template&id=4ea2e8df&scoped=true&lang=pug"
import script from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"
export * from "./BaseCheckboxGroup.vue?vue&type=script&lang=js"

import "./BaseCheckboxGroup.vue?vue&type=style&index=0&id=4ea2e8df&scoped=true&lang=scss"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ea2e8df"]])

export default __exports__